import {IntlShape} from "react-intl"


export const individualsHeader = (intl: IntlShape) => {
    return {
        id: intl.formatMessage({ id: "creator.column.individual.id" }).toLowerCase(),
        enabled: intl.formatMessage({ id: "creator.column.individual.enabled" }).toLowerCase(),
        sex: intl.formatMessage({ id: "creator.column.individual.sex" }).toLowerCase(),
        givenName: intl.formatMessage({ id: "creator.column.individual.name" }).toLowerCase(),
        // Full name pattern locale-specific columns
        middleName: intl.formatMessage({ id: "creator.column.individual.middlename" }).toLowerCase().replace(/\s+/g, "_"),
        surname1: intl.formatMessage({ id: "creator.column.individual.surname1" }).toLowerCase().replace(/\s+/g, "_"),
        surname2: intl.formatMessage({ id: "creator.column.individual.surname2" }).toLowerCase().replace(/\s+/g, "_"),
        nickname: intl.formatMessage({ id: "creator.column.individual.nickname" }).toLowerCase().replace(/\s+/g, "_"),
        // --
        birthDate: intl.formatMessage({ id: "creator.column.individual.birthDate" }).toLowerCase().replace(/\s+/g, "_"),
        birthPlace: intl.formatMessage({ id: "creator.column.individual.birthPlace" }).toLowerCase().replace(/\s+/g, "_"),
        deceaseDate: intl.formatMessage({ id: "creator.column.individual.deceaseDate" }).toLowerCase().replace(/\s+/g, "_"),
        deceasePlace: intl.formatMessage({ id: "creator.column.individual.deceasePlace" }).toLowerCase().replace(/\s+/g, "_"),
        // GEDCOM custom tags
        ethnicity: intl.formatMessage({ id: "config.ethnicity" }).toLowerCase(),
        languages: intl.formatMessage({ id: "config.languages" }).toLowerCase(),
        // Parents
        fatherId: intl.formatMessage({ id: "creator.column.individual.fatherId" }).toLowerCase().replace(/\s+/g, "_"),
        motherId: intl.formatMessage({ id: "creator.column.individual.motherId" }).toLowerCase().replace(/\s+/g, "_"),
        notes: intl.formatMessage({ id: "creator.column.individual.notes" }).toLowerCase().replace(/\s+/g, "_"),
        ...{ __SEP__: "" },
        // GEDCOM bindings
        numberOfChildren: intl.formatMessage({ id: "creator.extras.number.children" }).toLowerCase().replace(/\s+/g, "_"),
        familyChild: intl.formatMessage({ id: "creator.extras.family.child" }).toLowerCase().replace(/\s+/g, "_"),
        numberOfMarriages: intl.formatMessage({ id: "creator.extras.number.marriages" }).toLowerCase().replace(/\s+/g, "_"),
        familySpouses: intl.formatMessage({ id: "creator.extras.family.spouse" }).toLowerCase().replace(/\s+/g, "_")
    }
}